import React, { createContext, useContext, useState } from 'react';

const OrderContext = createContext({ page: 0, size: 10, searchWrd: '', certType: '' });

const OrderProvider = ({ children }) => {
    const [options, setOptions] = useState({ page: 0, size: 10, searchWrd: '', certType: '' });

    const value = {
        options,
        setOptions
    };

    return <OrderContext.Provider value={value}>{children}</OrderContext.Provider>;
};

const useOrderContext = () => {
    return useContext(OrderContext);
};

export { OrderProvider, useOrderContext };
